import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { Region } from 'stores/type';
import { auConfig, nzConfig } from 'config';

export const useRegionConfig = () => {
    const region = useSelector<RootState, Region>(state => state.userInfo.region);
    return region === Region.NZ ? nzConfig : auConfig;
};
